import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBgrg6OHSQJrBgB34Wm4RwdZF4RV7GJ_KA",
  authDomain: "ymmvdeals.firebaseapp.com",
  projectId: "ymmvdeals",
  storageBucket: "ymmvdeals.firebasestorage.app",
  messagingSenderId: "1003789322064",
  appId: "1:1003789322064:web:9941cd559e130bb4d1ce55",
  measurementId: "G-YJZN6VZHPH"
};



export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

// in firebase.js or before login
setPersistence(auth, browserLocalPersistence).catch((err) =>
  console.error("Persistence error", err)
);

export const provider = new GoogleAuthProvider();